import { STORAGE_KEYS } from '@/utils/storageKeys'

const DELIVERY_KEY = 'veltrix_refresh_delivery'

function defaultHttpOnlyGuess() {
  const v = import.meta.env.VITE_AUTH_REFRESH_HTTPONLY
  if (v === 'true') return true
  if (v === 'false') return false
  // Alinhar ao backend por omissão: cookie apenas em páginas servidas por HTTPS.
  try {
    return window.location.protocol === 'https:'
  } catch {
    return false
  }
}

export function usesHttpOnlyRefresh() {
  const stored = sessionStorage.getItem(DELIVERY_KEY)
  if (stored === 'http_only_cookie') return true
  if (stored === 'body') return false
  return defaultHttpOnlyGuess()
}

export function setRefreshTokenDelivery(mode) {
  if (mode === 'http_only_cookie' || mode === 'body') {
    sessionStorage.setItem(DELIVERY_KEY, mode)
  }
}

export function clearRefreshTokenDelivery() {
  sessionStorage.removeItem(DELIVERY_KEY)
}

/** Remove refresh legado do localStorage (migração para cookie HttpOnly). */
export function purgeLegacyRefreshFromStorage() {
  localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
  localStorage.removeItem(STORAGE_KEYS.ADMIN_REFRESH_TOKEN)
}
